import { render, staticRenderFns } from "./ReminderMMLite.vue?vue&type=template&id=6d389fbb"
import script from "./ReminderMMLite.vue?vue&type=script&lang=js"
export * from "./ReminderMMLite.vue?vue&type=script&lang=js"
import style0 from "./ReminderMMLite.vue?vue&type=style&index=0&id=6d389fbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports